module.exports = __webpack_public_path__ + "static/media/hover_image_button1.757af024.png";